export default __webpack_public_path__ + "5c9ad728cf84a92ace8f1be5cb925570.png";